import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export interface TransferOwnershipDialogProps {
  open: boolean;
  userName?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const TransferOwnershipDialog = ({
  open,
  userName,
  onConfirm,
  onCancel,
}: TransferOwnershipDialogProps) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>Transfer account ownership</DialogTitle>
    <DialogContent>
      <Typography variant="body1" sx={{ mb: 2 }}>
        You are about to make {userName ?? "this user"} the account Owner.
      </Typography>
      <Typography variant="body2" sx={{ color: "#d32f2f" }}>
        <strong>Warning:</strong> You will become an Admin and lose Owner
        permissions, including pricing and billing. Only the new Owner can
        transfer ownership back.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 3 }}>
      <Button onClick={onCancel} sx={{ textTransform: "none" }}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        sx={{
          bgcolor: "#ff8c00",
          color: "#fff",
          textTransform: "none",
          "&:hover": { bgcolor: "#e67e00" },
        }}
      >
        Transfer ownership
      </Button>
    </DialogActions>
  </Dialog>
);
